// Core
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, NavLink } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
    MenuOutlined,
    UserOutlined
} from "@ant-design/icons";
// Assets

// Styles
import Button from '../Button';
import { DrawerItems, HeaderOuter, HeaderWrapper, LogoText, TopMenu } from './styles';
import { Avatar, Drawer } from 'antd';
import Login from 'modals/Login';
import { APP_ID } from 'config/constants';
import { fetchData } from 'utils/fetch';
import { restAPIs } from 'utils/restAPIs';
import i18n from 'locales/i18n';

const Header: React.FC = () => {
    const { userDetails, currentLang } = useSelector((store: any) => store.commonData);
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const dispatch = useDispatch();
    const [loginShow, setLogin] = useState(false);
    const [currLng, setCurrLng] = useState('ENG')

    const showDrawer = () => {
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    const handleLogin = () => {
        setLogin(true)
    }

    const handleChangeLang = async (value: any) => {
        setCurrLng(value === 'ar' ? 'عربي' : 'ENG')
        i18n.changeLanguage(value);
        dispatch({
            type: 'currentLang',
            value: { lang: value, id: value === 'ar' ? 1 : 2 }
        });
        if (value === 'ar') {
            document.body.classList.add('arabic');
        }
        else {
            document.body.classList.remove('arabic')
        }
        const localDetails = localStorage.getItem('userDetails');
        if (localDetails) {
            const formData = new FormData();
            formData.append('language', value);
            formData.append('appId', APP_ID);
            const res = await fetchData(restAPIs.changeLanguage(formData));
            if (res.statusCode === 200) {
                dispatch({
                    type: 'userDetails',
                    value: { ...userDetails, language: res.language }
                });
            }
        }
    };


    useEffect(() => {
        const localDetails = localStorage.getItem('userDetails');
        if (currentLang.lang === 'ar') {
            document.body.classList.add('arabic');
        }
        else {
            document.body.classList.remove('arabic')
        }

        if (localDetails) {
            checkSubsription();
        }
        else {
            i18n.changeLanguage(currentLang.lang);
        }
    }, []);


    const checkSubsription = async () => {
        const formD = new FormData();
        formD.append('appId', APP_ID)
        const res = await fetchData(restAPIs.subscriptionForm(formD));
        dispatch({
            type: 'userDetails',
            value: { ...res, language: res.language == "1" ? 'ar' : 'en' }
        });
        localStorage.setItem('userDetails', JSON.stringify(res));
        localStorage.setItem('sessiontoken', res.sessionToken);
        i18n.changeLanguage(res.language == "1" ? 'ar' : 'en');
        dispatch({
            type: 'currentLang',
            value: { lang: res.language == "1" ? 'ar' : 'en', id: +res.language }
        });

        if (res.language == "1") {
            document.body.classList.add('arabic');
        }
        else {
            document.body.classList.remove('arabic')
        }

    }



    return (
        <HeaderOuter>
            <div className='container'>
                <HeaderWrapper>
                    <LogoText >
                        <MenuOutlined onClick={showDrawer} />
                        <NavLink to={'home'} end>Ahlamakom</NavLink>
                    </LogoText>
                    <TopMenu>
                        <NavLink to={'about'} end >{t('about_us')}</NavLink>
                        <NavLink to={'dreams'} end>Dreams</NavLink>
                        <NavLink to={'books'} end>Books</NavLink>
                        <NavLink to={'contact'} end>{t('contact_us')}</NavLink>
                    </TopMenu>

                    {userDetails?.fullname ? <NavLink to={'settings'} end style={{ color: '#fff', textDecoration: 'none' }}><Avatar src={<img src={userDetails?.profile_pic} alt={userDetails?.fullname} />} /></NavLink> : <button onClick={() => setLogin(true)}><UserOutlined /></button>}

                </HeaderWrapper>
            </div>
            <Drawer placement='left' title={<span>Ahlamakom</span>} onClose={onClose} open={open} className='__drawer'>
                <DrawerItems>
                    <NavLink to={'about'} end onClick={onClose}>{t('about_us')}</NavLink>
                    <NavLink to={'dreams'} end onClick={onClose}>Dreams</NavLink>
                    <NavLink to={'books'} end onClick={onClose}>Books</NavLink>
                    <NavLink to={'contact'} end onClick={onClose}>{t('contact_us')}</NavLink>
                </DrawerItems>
            </Drawer>
            <Login
                open={loginShow}
                onClose={() => setLogin(false)}
            />

        </HeaderOuter>
    );
};

export default Header;
